<template>
  <div>
    <router-link to="dataSourceMain" style="color: darkblue;float: left;padding-left: 2%;">
    返回
    </router-link>
    <router-link to="dataSetMain" style="color: darkblue;float:right;padding-right: 2%" @click.native="saveDataSetDetail">
      保存
    </router-link>
<!--    <router-link to="dataSetMain" style="color: darkblue;float:right;padding-right: 2%">-->
<!--        -->
<!--    </router-link>-->
  <div class="pageCla">
<!--    <h1>定义数据集</h1>-->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="单表查询" name="first">单表查询</el-tab-pane>
      <el-tab-pane label="Sql语句查询" name="second">
          <el-form :ref="dbList" class="elformCla" :model="dbList">
            <el-form-item label="名称：" size="small">
              <label slot="label">&emsp;&emsp;&emsp;&ensp;名称：</label>
              <el-col span="7">
                <el-input type="text" size="" v-model="dbList.dsName"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Sql语句查询：" size="max">
              <el-col span="13">
                <el-input type="textarea" style="width: 100%" v-model="dbList.dsId"></el-input>
              </el-col>
              <el-col class="button" span="2">
                <el-button type="primary" size="small" @click="analysSql">解析Sql&emsp;</el-button>
              </el-col>
            </el-form-item>
            <el-col class="buttonCla">
              <el-button type="primary" size="small" @click="addCol">&emsp;新增&emsp;</el-button>
            </el-col>
            <el-table :data="tableDataSecond" style="width: 80%;margin-top: 5px;border: #ebeef5 1px solid;"  @row-click="getDetails">
                <el-table-column prop="id" label="主键id" width="150;" v-if="show"></el-table-column>
                <el-table-column prop="ds_id" label="数据集id" width="150;" v-if="show"></el-table-column>
                <el-table-column prop="field_id" label="字段标识" width="150"></el-table-column>
                <el-table-column prop="field_name" label="展示名称" width="120"></el-table-column>
                <el-table-column prop="field_en_name" label="展示名称英文" width="120"></el-table-column>
                <el-table-column prop="field_ch_en_name" label="展示名称中英文" width="300"></el-table-column>
                <el-table-column prop="" label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button type="text" @click="editCol(scope.row)">修改</el-button>
                    <el-button type="text" @click="deleteCol(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
          </el-form>
      </el-tab-pane>
      <el-tab-pane label="自定义URL" name="third">自定义URL</el-tab-pane>
      <el-tab-pane label="导入Excel" name="fourth">导入Excel</el-tab-pane>
      <el-tab-pane label="客户查询" name="fifth">
        <el-form class="elformCla" :ref="cusForm" :model="cusForm">
          <el-form-item label="名称：" size="small">
            <label slot="label">&emsp;&emsp;&emsp;&emsp;名称：</label>
            <el-col span="7">
              <el-input type="text" size="" v-model="cusForm.dsName"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="选择客户：" size="small">
            <label slot="label">&emsp;&emsp;选择客户：</label>
            <el-col span="7">
              <el-select type="text" style="width: 100%" filterable remote :remote-method="remoteMethod" :loading="loading" placeholder="请输入关键词" v-model="cusForm.cusName" value-key="cusId">
                <el-option type="text" v-for="(cus, index) in options"
                           :key="cus.cusId"
                           :label="cus.cusName"
                           :value="cus"
                ></el-option>
              </el-select>
            </el-col>
          </el-form-item>
          <el-form-item label="Sql语句：" size="max">
            <label slot="label">&emsp;&emsp;&ensp;Sql语句：</label>
            <el-col span="13">
              <el-input type="textarea" style="width: 100%" v-model="cusForm.dsId"></el-input>
            </el-col>
          </el-form-item>
          <el-col class="cusButtonCla">
            <el-button type="primary" size="small" @click="cusTableAdd">&emsp;新增&emsp;</el-button>
          </el-col>
          <el-table :data="tableDataFifth" style="width: 70%;margin-top: 5px;border: #ebeef5 1px solid;" @selection-change="">
<!--            <el-table-column prop="cusName" label="客户" width="300" align="center"></el-table-column>-->
            <el-table-column prop="table_id" label="表" width="300" align="center"></el-table-column>
            <el-table-column prop="table_name" label="表名称" width="450" align="center"></el-table-column>
          </el-table>
        </el-form>
      </el-tab-pane>
    </el-tabs>
  </div>
  </div>
</template>

<script>
    export default {
      data(){
          return{
            activeName:'second',
            show: false,
            dbList:{
              dsId : '',
              dsName : '',
              id:'',
              dbSourceId:'',
            },
            cusForm:{
              dsName: '',
              dsId: '',
              cusName: '',
              id:'',
              dbSourceId:'',
              cusId:''
            },
            tableDataSecond:[],
            tableDataFifth:[],
            //客户列表
            cusList:[],
            options:[],
            loading:false
          }
      },
      mounted(){
        // alert(this.$route.query.id);
        if (this.$route.query.id != undefined) {
          this.cusForm.dbSourceId = this.$route.query.id;
          this.dbList.dbSourceId = this.$route.query.id;
        }
        if (this.$route.params.avtiveName != undefined) {
          this.activeName = this.$route.params.avtiveName;
        }

        this.queryCusList();
      },
      activated() {
        if (this.$route.params.addFlag == '1' && this.$route.params.dsId != undefined) {
          sessionStorage.getItem("dbList");
          this.cusForm.id = this.$route.params.dsId;
          this.queryTable(this.cusForm.id);
        }
        if (this.$route.params.list != undefined && this.$route.params.flags == '1') {
          sessionStorage.getItem("dbList");
          this.tableDataSecond = this.$route.params.list;
        }
      },
      methods:{
        addCol(){
          this.$router.push({name:'addDataSetCol', params:{ds_id: this.dbList.id}});
        },
        editCol(row){
          this.$router.push({name:'addDataSetCol', params:{id:row.id,
                                                           ds_id:row.ds_id,
                                                           field_id: row.field_id,
                                                           field_name:row.field_name,
                                                           field_en_name:row.field_en_name,
                                                           field_ch_en_name:row.field_ch_en_name, flag:'edit'}});
        },
        deleteCol(row){
          let params = {id: row.id}
          this.$http.post("/dbManage/sys-dataset-detail/deleteCol", params).then(resp=>{
            this.tableDataSecond = resp.data;
          })
        },
        //解析Sql
        analysSql(){
          var params = {
            sqlContent: this.dbList.dsId
          }
          this.$http.post("/dbManage/sys-dataset-detail/analysSql",params).then(resp=>{
            this.tableDataSecond = resp.data;
            this.dbList.id = resp.data[0].ds_id;
          })
          sessionStorage.setItem("dbList", this.dbList);
        },
        //保存页面输入信息
        saveDataSetDetail(){
          if (this.activeName == 'second') {
            this.$http.post("/dbManage/sys-dataset/saveInfo", this.dbList).then(resp=>{
              this.$alert('保存成功！','提示信息',{
                confirmButtonText: '确定',
              })
            })
          }
          if (this.activeName == 'fifth') {
            this.cusForm.cusName = this.cusForm.cusName.cusName;
            this.cusForm.cusId = this.cusForm.cusName.cusId;
            this.$http.post("/dbManage/sys-dataset/saveDataSet", this.cusForm).then(resp=>{
              this.$alert('保存成功！','提示信息',{
                confirmButtonText: '确定',
              })
            })
          }
        },
        //查询客户列表
        queryCusList(){
          const that = this;
          this.$http.post("/dbManage/sys-dataset-detail/queryCusList").then(resp=>{
            that.cusList = resp.data;

            that.$forceUpdate();
          })
        },
        //客户查询-新增
        cusTableAdd(){
          this.$router.push({name:'addDataSet', params:{dsId: this.cusForm.id}});
        },
        queryTable(dsId){
            var params = {dsId: dsId}
            this.$http.post("/dbManage/sys-dataset-detail/queryData",params).then(resp=>{
              console.log(resp.data)
              this.tableDataFifth = resp.data;
          })
        },
        remoteMethod(query) {
          const that = this;
          if (query !== '') {
            this.loading = true;
            let len = this.cusList.length;
            this.options = this.cusList.filter((item,index) => {
              if(item.cusName){
                return item.cusName.indexOf(query) > -1
              }
            })
            this.$nextTick(() => {
              that.loading = false;
            })
          } else {
            this.options = [];
          }
        }
      }
    }
</script>

<style scoped>
.pageCla{
  width: 95%;
  margin-left: 2%;
  margin-top: 3%;
}
.elformCla{
  padding-left: 15%;
  padding-top: 2%;
  }
.buttonCla{
  padding-left: 45%;
  padding-bottom: 5px;
  }
.cusButtonCla{
  padding-left: 30%;
  padding-bottom: 5px;
}
.button{
    padding-left: 1%;
  }
</style>



// WEBPACK FOOTER //
// src/components/dataSource/defineDataSet.vue